import {useEffect, useState} from "react";

const EstateLoading=()=>{
    const [animationKey, setAnimationKey] = useState(0);
    const [animationKey1, setAnimationKey1] = useState(0);
    const [animationKey2, setAnimationKey2] = useState(0);
    useEffect(() => {
        const intervalId = setInterval(() => {
            setAnimationKey((prevKey) => prevKey + 1);
        }, 3400);


        return () => {
            clearInterval(intervalId)

        };
    }, []);
    useEffect(() => {
        const intervalId1 = setInterval(() => {
            setAnimationKey1((prevKey) => prevKey + 1);
        }, 3400);


        return () => {
            clearInterval(intervalId1)

        };
    }, []);
    useEffect(() => {
        const intervalId2 = setInterval(() => {
            setAnimationKey2((prevKey) => prevKey + 1);
        }, 3400);


        return () => {
            clearInterval(intervalId2)

        };
    }, []);
    return <div className="estate-loading">
        <svg  xmlns="http://www.w3.org/2000/svg" width="200" height="70.58" viewBox="0 0 418 157.58">
            <g id="Group_1258" data-name="Group 1258" transform="translate(-764 -2321.71)">
                <g id="home_3"  key={animationKey+'animation_0'}  transform="translate(727.425 2399.44)">
                    <rect id="Rectangle_599" data-name="Rectangle 599" width="77.74" height="55.14" transform="translate(436.62 279.36) rotate(180)" fill="#e3e3e3"/>
                    <path id="Path_3801" data-name="Path 3801" d="M287.73,225.07v54.28h71.16V224.01L324.1,189.23Z" fill="#efefef"/>
                    <path id="Path_3802" data-name="Path 3802" d="M436.64,224.38,399.75,188.7l-75.65.57,34.79,35.11Z" fill="#79d6ab"/>
                    <rect id="Rectangle_600" data-name="Rectangle 600" width="11.17" height="18.1" transform="translate(402.73 258.64) rotate(180)" fill="#2d3962"/>
                    <rect id="Rectangle_601" data-name="Rectangle 601" width="11.17" height="18.1" transform="translate(422.94 258.64) rotate(180)" fill="#2d3962"/>
                    <rect id="Rectangle_602" data-name="Rectangle 602" width="11.17" height="18.1" transform="translate(382.59 258.64) rotate(180)" fill="#2d3962"/>
                    <path id="Path_3803" data-name="Path 3803" d="M323.51,227.39h0a8.245,8.245,0,0,1-8.25-8.25h0a8.245,8.245,0,0,1,8.25-8.25h0a8.245,8.245,0,0,1,8.25,8.25h0A8.245,8.245,0,0,1,323.51,227.39Z" fill="#2d3962"/>
                    <rect id="Rectangle_603" data-name="Rectangle 603" width="15.57" height="24.9" transform="translate(316.37 254.46)" fill="#2d3962"/>
                </g>
                <g id="home_2"  key={animationKey1+'animation_1'}  transform="translate(727.425 2399.44)">
                    <rect id="Rectangle_604" data-name="Rectangle 604" width="60.44" height="121.57" transform="translate(294.87 279.35) rotate(180)" fill="#dfdfdf"/>
                    <path id="Path_3804" data-name="Path 3804" d="M163.27,158.64V279.35h71.15V157.58L199.63,122.8Z" fill="#efefef"/>
                    <path id="Path_3805" data-name="Path 3805" d="M294.89,157.95l-36.9-35.68-58.36.57,34.79,35.11Z" fill="#79d6ab"/>
                    <path id="Path_3806" data-name="Path 3806" d="M198.79,186.53h0a8.821,8.821,0,0,1-8.82-8.82h0a8.821,8.821,0,0,1,8.82-8.82h0a8.821,8.821,0,0,1,8.82,8.82h0a8.821,8.821,0,0,1-8.82,8.82Z" fill="#2d3962"/>
                    <rect id="Rectangle_605" data-name="Rectangle 605" width="17.65" height="17.65" transform="translate(254.1 184.69)" fill="#2d3962"/>
                    <rect id="Rectangle_606" data-name="Rectangle 606" width="17.65" height="17.65" transform="translate(254.1 227.23)" fill="#2d3962"/>
                </g>
                <g id="home_1" key={animationKey2+'animation_2'}  transform="translate(727.425 2399.44)">
                    <g id="Group_1257" data-name="Group 1257" >
                        <rect id="Rectangle_607" data-name="Rectangle 607" width="60.44" height="55.14" transform="translate(207.93 279.36) rotate(180)" fill="#dfdfdf"/>
                        <path id="Path_3807" data-name="Path 3807" d="M76.34,225.07v54.28h71.15V224.01L112.7,189.23Z" fill="#efefef"/>
                        <path id="Path_3808" data-name="Path 3808" d="M207.96,224.38l-36.9-35.68-58.36.57,34.79,35.11Z" fill="#79d6ab"/>
                        <rect id="Rectangle_608" data-name="Rectangle 608" width="11.17" height="18.1" transform="translate(189.92 258.64) rotate(180)" fill="#2d3962"/>
                        <rect id="Rectangle_609" data-name="Rectangle 609" width="11.17" height="18.1" transform="translate(170.06 258.64) rotate(180)" fill="#2d3962"/>
                        <rect id="Rectangle_610" data-name="Rectangle 610" width="17.65" height="17.65" transform="translate(102.73 223.63)" fill="#2d3962"/>
                    </g>
                </g>
                <line id="Line_152" data-name="Line 152" x2="418" transform="translate(764 2478.79)" fill="none" stroke="#e2dede" strokeWidth="1"/>
            </g>
        </svg>
    </div>
}
export default EstateLoading;